import {
  getBottomPinnedLegendEnabled,
  setBottomPinnedLegend,
} from '@neptune/shared/bottom-pinned-legend-business-logic';
import {
  DB_PERSISTED_LEGEND_POSITION_CONFIG_KEY,
  DbPersistedLegendPositionConfig,
  isLegendPosition,
  LegendPosition,
} from '@neptune/shared/layout-configuration-domain';

type ReduxStore = {
  getState: () => any;
  dispatch: (action: any) => void;
};

export type DbPersistedPreferences = DbPersistedLegendPositionConfig;

export type PreferencesStore = {
  initialize(store: ReduxStore): void;
  getLegendPosition(): LegendPosition;
  setLegendPosition(position: LegendPosition): void;
  isLegendPositionConfigKeyValid(key: string): boolean;
};

export function createPreferencesStore(): PreferencesStore {
  let reduxStore: ReduxStore | null = null;

  function initialize(store: ReduxStore): void {
    reduxStore = store;
  }

  function getLegendPosition(): LegendPosition {
    if (!reduxStore) {
      throw new Error('PreferencesStore not initialized. Call initialize(store) first.');
    }

    const state = reduxStore.getState();
    const bottomPinnedLegend = getBottomPinnedLegendEnabled(state);

    return bottomPinnedLegend ? LegendPosition.ATTACHED : LegendPosition.FLOATING;
  }

  function setLegendPosition(position: LegendPosition): void {
    if (!reduxStore) {
      throw new Error('PreferencesStore not initialized. Call initialize(store) first.');
    }

    const pinned = position === LegendPosition.ATTACHED;

    reduxStore.dispatch(setBottomPinnedLegend(pinned));
  }

  function isLegendPositionConfigKeyValid(key: string): boolean {
    return DB_PERSISTED_LEGEND_POSITION_CONFIG_KEY === key;
  }

  return {
    initialize,
    getLegendPosition,
    setLegendPosition,
    isLegendPositionConfigKeyValid,
  };
}

export const preferencesStore = createPreferencesStore();

export { isLegendPosition };
